import { render, staticRenderFns } from "./MySider.vue?vue&type=template&id=4cf7739a&scoped=true&"
import script from "./MySider.vue?vue&type=script&lang=js&"
export * from "./MySider.vue?vue&type=script&lang=js&"
import style0 from "./MySider.vue?vue&type=style&index=0&id=4cf7739a&scoped=true&lang=scss&"
import style1 from "./MySider.vue?vue&type=style&index=1&id=4cf7739a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf7739a",
  null
  
)

export default component.exports